module.exports = __webpack_public_path__ + "img/15.38c26342.png";